var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"data-table-cell-service"},[_c('ui-icon',{staticClass:"data-table-cell-service__icon",attrs:{"glyph":_vm.glyph,"title":_vm.serviceName}}),(!_vm.iconOnly)?_c('div',{staticClass:"data-table-cell-service__label"},[_vm._v(_vm._s(_vm.serviceName))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }